import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Formats a text input as HH:MM while typing: digits only, colon auto-inserted,
 * and digits that would make an impossible hour/minute (e.g. hour > 23) are rejected.
 */
@Directive({
  selector: '[appTimeMask]',
  standalone: false,
})
export class TimeMaskDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '').slice(0, 4);
    const masked = this.applyMask(digits);
    input.value = masked;
    input.setSelectionRange(masked.length, masked.length);
    this.ngControl.control?.setValue(masked);
  }

  private applyMask(digits: string): string {
    let hour = '';
    let minute = '';
    for (const d of digits) {
      if (hour.length < 2) {
        if (hour.length === 0 ? Number(d) <= 2 : (hour === '2' ? Number(d) <= 3 : true)) {
          hour += d;
        }
      } else if (minute.length < 2) {
        if (minute.length === 0 ? Number(d) <= 5 : true) {
          minute += d;
        }
      }
    }
    return minute ? `${hour}:${minute}` : hour;
  }
}
